import $ from 'jquery';
import processInclude from './util';
import * as productCount from './header/wishlist';

import '~base';

$(document).ready(() => {
  processInclude(productCount);
});
